import React from "react";
import { Link } from "react-router-dom";

const TrialBanner = ({ trialEndsAt }) => (
  <div className="w-full bg-yellow-100 border-b border-yellow-400 text-yellow-800 px-4 py-2 flex items-center justify-center gap-4 font-semibold z-50">
    <div className="flex items-center gap-1">
      <span role="img" aria-label="clock">⏳</span>
      <span>
        You are currently on a <span className="font-bold">trial period</span>.
        {trialEndsAt && (
          <> Your trial ends on <span className="font-bold">{new Date(trialEndsAt).toLocaleDateString()}</span>.</>
        )}
      </span>
    </div>
    <Link 
      to="/settings" 
      className="bg-yellow-800 text-white px-3 py-1 rounded-md text-sm hover:bg-yellow-900 transition-colors"
    >
      Upgrade Now
    </Link>
  </div>
);

export default TrialBanner;